import React, { useContext, useEffect, useState } from 'react'
import { useAdminAutoTrades } from '_hooks/useAdminAutoTrades'
import { ErrorMessage } from 'components/common/ErrorMessage';
import { Spinner } from 'components/common/Spinner';
import { useSearchParams } from 'react-router-dom';
import {
  AutoTradeManagementTypeEnumHelper,
  AutoTradePositionTypeEnum,
  AutoTradePositionTypeEnumHelper,
  AutoTradeStatusEnum,
  AutoTradeStatusEnumHelper, IAutoTrade,
  IBKRSide,
  NewYorkTz,
} from 'predictagram-lib';
import { IAutoTradeSearchFilter, adminApiServiceCommon } from "../../../services/AdminApiService";
import { MessengerContext } from "../../common/messenger";
import { StatusFilter } from './filters/StatusFilter';
import { SideFilter } from './filters/SideFilter';
import { IDateRangeFilter, OpenedFilter } from './filters/OpenedFilter';
import { Link } from 'react-router-dom';
import { UrlHelper } from '_utils/UrlHelper';
import * as Icons from 'react-bootstrap-icons';
import { PositionTypeFilter } from './filters/PositionTypeFilter';
import { PresetDateRange, PresetDateRangeFilter } from './filters/PresetDateRangeFilter';
import { useExcelDownload } from '_hooks/useExcelDownload';

import { SortUp, SortDown } from 'react-bootstrap-icons'
import { ISortColumn, TableColumn, TradeModel } from 'models/trade.model';

export const TradesListPage: React.FunctionComponent = () => {

  const msgrContext = useContext(MessengerContext);
  const [searchParams] = useSearchParams();
  const setupId = searchParams.get('setupId');

  // filters
  const [statusFilter, setStatusFilter] = useState<AutoTradeStatusEnum | undefined>(undefined);
  const [sideFilter, setSideFilter] = useState<IBKRSide | undefined>(undefined);
  const [positionTypeFilter, setPositionTypeFilter] = useState<AutoTradePositionTypeEnum | undefined>(undefined);
  const [presetDateRangeFilter, setPresetDateRangeFilter] = useState<PresetDateRange | undefined>(setupId ? undefined : PresetDateRange.TODAY);
  const [openedFilter, setOpenedFilter] = useState<IDateRangeFilter | undefined>(TradeModel.getOpenedFilterFromPreset(presetDateRangeFilter));

  const searchFilter: IAutoTradeSearchFilter = {
    startTime: openedFilter?.startTime,
    endTime: openedFilter?.endTime,
  }
  const api = useAdminAutoTrades(searchFilter);

  const [data, setData] = useState<IAutoTrade[]>([]);
  const [filteredData, setFilteredData] = useState<IAutoTrade[]>([]);

  // table columns
  const tableColumns: TableColumn[] = TradeModel.tradeListTableColumns;
  // sort
  const defaultSort: ISortColumn = { tableColumn: tableColumns[0], direction: "asc" };
  const [sortColumn, setSortColumn] = useState<ISortColumn>(defaultSort);

  const mapper = (item: any) => {
    return {
      ...item,
      openedOn: NewYorkTz.format(new Date(item.openAt * 1000)).monthNameDateTime(),
      closedOn: item.closeAt ? NewYorkTz.format(new Date(item.closeAt * 1000)).monthNameDateTime() : '',
      openPrice: item.ibkrOpenOrder ? item.ibkrOpenOrder.orderPrice : '',
      closePrice: item.ibkrCloseOrder ? item.ibkrCloseOrder.orderPrice : '',
      ibkrOpenOrder: JSON.stringify(item.ibkrOpenOrder, null, 2),
      ibkrCloseOrder: JSON.stringify(item.ibkrCloseOrder, null, 2),
    }
  }
  const excelDownload = useExcelDownload<any>(mapper, 'trades');


  useEffect(() => {
    const loadPrices = async () => {
      const trades = [];
      if (!api.apiState.isLoaded) {
        return;
      }
      if (api.data) {
        setData(api.data);
      }
      for (const d of api.data) {
        // show prices only for a successful trades
        if (d.ibkrOpenOrder) {
          try {
            (d as any).livePrices = await adminApiServiceCommon.getTradeLivePrices(d.id);
            // console.debug(d);
          } catch (e) {
            console.error(e)
          }
        }
      }
      trades.push(...api.data);
      setData(trades
        .sort((a, b) => {
          if (sortColumn.tableColumn.comparator) {
            return sortColumn.tableColumn.comparator(a, b, sortColumn.direction);
          }

          // default comparator if no comparator
          const valueA = a[sortColumn.tableColumn.name as keyof IAutoTrade].toString();
          const valueB = b[sortColumn.tableColumn.name as keyof IAutoTrade].toString();
          return TradeModel.compareHelper(valueA, valueB, sortColumn.direction);
        })
      );
    };

    loadPrices();
  }, [api.data, api.apiState.isLoaded, sortColumn.tableColumn, sortColumn.direction]);


  useEffect(()=>{
    if (api.apiState.isLoaded) {
      setFilteredData(api.data
        .filter(trade => setupId ? trade.setupId === parseInt(setupId) : true)
        .filter(trade => sideFilter ? trade.ibkrOpenOrder?.orderSide.toString() === sideFilter.toString() : true)
        .filter(trade => positionTypeFilter ? trade.positionTypeId.toString() === positionTypeFilter.toString() : true)
      )
    }
  }, [api.apiState.isLoaded, api.data, positionTypeFilter, sideFilter, setupId])

  useEffect(() => {

    if (api.apiState.isLoaded) {

      const searchFilter: IAutoTradeSearchFilter = {
        startTime: openedFilter?.startTime,
        endTime: openedFilter?.endTime,
        autoTradeStatusIds: statusFilter ? [statusFilter] : undefined,
      }

      api.setFilter(searchFilter);

      // setData(api.data.filter(trade => setupId ? trade.setupId === parseInt(setupId) : true)
      //   .filter(trade => statusFilter ? trade.statusId.toString() === statusFilter.toString() : true)
      //   .filter(trade => sideFilter ? trade.ibkrOpenOrder?.orderSide.toString() === sideFilter.toString() : true)
      //   .filter(trade => positionTypeFilter ? trade.positionTypeId.toString() === positionTypeFilter.toString() : true)
      //   .filter(trade => openedFilter ? (
      //     (openedFilter.startTime ? trade.openAt >= openedFilter.startTime : true) &&
      //     (openedFilter.endTime ? trade.openAt <= openedFilter.endTime : true)
      //   ) : true)
      //   .sort((a, b) => {
      //     if (sortColumn.tableColumn.comparator) {
      //       return sortColumn.tableColumn.comparator(a, b, sortColumn.direction);
      //     }

      //     // default comparator if no comparator
      //     const valueA = a[sortColumn.tableColumn.name as keyof IAutoTrade].toString();
      //     const valueB = b[sortColumn.tableColumn.name as keyof IAutoTrade].toString();
      //     return TradeModel.compareHelper(valueA, valueB, sortColumn.direction);
      //   }));
    }
  }, [openedFilter?.endTime, openedFilter?.startTime, statusFilter])


  useEffect(() => {
    const openedFilter = TradeModel.getOpenedFilterFromPreset(presetDateRangeFilter);
    setOpenedFilter(openedFilter);
  }, [presetDateRangeFilter])

  const closeTrade = async (id: number) => {
    const res = await adminApiServiceCommon.closeTrade(id);
    if (res) {
      msgrContext.setMessage({ body: `Closed ${id}` });
      api.setFilter({});
    } else {
      msgrContext.setMessage({ body: 'Error' });
    }
  }

  const addTrade = async (id: number) => {
    const res = await adminApiServiceCommon.addTrade(id);
    if (res) {
      msgrContext.setMessage({ body: `Added #${res.id}` });
      api.setFilter({});
    } else {
      msgrContext.setMessage({ body: 'Error' });
    }
  }

  const _setSortColumn = (tableColumn: TableColumn) => {
    const _sortColumn: ISortColumn = {
      tableColumn,
      direction: "asc"
    }

    if (sortColumn.tableColumn.name === tableColumn.name) {
      if (sortColumn.direction === "asc") {
        _sortColumn.direction = "desc"
      } else {
        _sortColumn.direction = "asc";
      }
    }
    setSortColumn(_sortColumn);
  }

  const renderSortIcon = (name: string) => {
    if (name === sortColumn.tableColumn.name) {
      if (sortColumn.direction === "asc") {
        return <SortUp />
      } else {
        return <SortDown />
      }
    }
    return <></>
  }



  if (api.apiState.isLoading) {
    return <Spinner />
  }

  if (api.apiState.isError) {
    return <ErrorMessage className="bg-white">{api.error}</ErrorMessage>
  }

  if (api.apiState.isLoaded) {
    return <div>
      <div className="page-title my-3">Trades</div>
      <div className="d-flex my-2 border rounded p-3 justify-content-between align-items-center">

        <div className="d-flex gap-2">
          <PresetDateRangeFilter value={presetDateRangeFilter} setValue={setPresetDateRangeFilter} />
          <OpenedFilter value={openedFilter} setValue={setOpenedFilter} />
          <SideFilter value={sideFilter} setValue={setSideFilter} />
          <PositionTypeFilter value={positionTypeFilter} setValue={setPositionTypeFilter} />
          <StatusFilter value={statusFilter} setValue={setStatusFilter} />
        </div>

        {api.data && api.data.length > 0 &&
          <div>{excelDownload.render(data)}</div>
        }
      </div>

      <div className="fixed-table-head">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              {tableColumns.map((tableColumn, index) => {
                if (!tableColumn.name) {
                  return <th key={`th-${index}`}><>{tableColumn.title}</></th>
                }
                return <th key={`th-${index}`} role="button" onClick={() => _setSortColumn(tableColumn)}>{tableColumn.title} {renderSortIcon(tableColumn.name)}</th>
              }
              )
              }
            </tr>
          </thead>
          <tbody>
            {filteredData.sort((a, b) => {

              if (sortColumn.tableColumn.comparator) {
                return sortColumn.tableColumn.comparator(a, b, sortColumn.direction);
              }

              // default comparator if no comparator
              const valueA = a[sortColumn.tableColumn.name as keyof IAutoTrade].toString();
              const valueB = b[sortColumn.tableColumn.name as keyof IAutoTrade].toString();
              return TradeModel.compareHelper(valueA, valueB, sortColumn.direction);
            })
              .map((trade, index) =>
                <tr key={`trade-${trade.id}`}>
                  <td>{trade.id}</td>
                  <td>
                    <div className="d-flex flex-nowrap gap-1 align-items-center">
                      <span className="text-nowrap">{trade.setupName}</span>
                      <div><Link target="_blank" to={UrlHelper.getAdminAutoTradeSetupEdit(trade.setupId)}><Icons.BoxArrowUpRight /></Link></div>
                    </div>
                  </td>
                  <td>{trade.ibkrOpenOrder?.orderSide} {trade.ibkrOpenOrder?.optionName}</td>
                  <td>{AutoTradePositionTypeEnumHelper.names.get(trade.positionTypeId)}</td>
                  <td>{trade.openQuantity}</td>
                  <td>{trade.ibkrOpenOrder?.orderPrice.toFixed(2)}</td>
                  <td>{trade.ibkrCloseOrder?.orderPrice.toFixed(2)}</td>
                  <td>{new Date(trade.openAt * 1000).toLocaleString()}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <button className="btn btn-primary" onClick={() => {
                        if (window.confirm('Continue with Add?')) {
                          addTrade(trade.id)
                        }}}>Add</button>
                      {trade.statusId === AutoTradeStatusEnum.ACTIVE &&
                        <button className="btn btn-primary" onClick={() => {
                          if (window.confirm('Are you sure you want to Close the trade?'))
                          closeTrade(trade.id)
                        }}>Close</button>
                      }
                    </div>
                  </td>
                  <td>{(trade as any).livePrices?.lastPrice}</td>
                  <td>{AutoTradeManagementTypeEnumHelper.names.get(trade.managementTypeId)}</td>
                  <td>{trade.closeAt ? new Date(trade.closeAt * 1000).toLocaleString() : ''}</td>
                  <td>{AutoTradeStatusEnumHelper.names.get(trade.statusId)}</td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    </div>
  }

  return <></>
}
